// import { useEffect } from 'react';
import { useQuery, useLazyQuery } from 'react-apollo';
import zenDeskBaseUrl from './zenDeskUrls';
import zendeskJwtGql from './gqlQuery';

export { zenDeskBaseUrl };
export const useZenDeskJwtLazy = () => {
  const [getJwt, { loading, error, data }] = useLazyQuery(zendeskJwtGql, {
    fetchPolicy: 'cache-and-network',
  });

  return {
    getJwt,
    loading,
    error,
    data,
  };
};
export const useZenDeskJwt = () => {
  const { error, data, loading } = useQuery(zendeskJwtGql, {
    fetchPolicy: 'network-only', // This needs to be network only, as it will fetch a new jwt
  });
  return { error, data, loading };
};
